import { render, staticRenderFns } from "./suscriptionHandler.vue?vue&type=template&id=60f2ee38&scoped=true&"
import script from "./suscriptionHandler.vue?vue&type=script&lang=js&"
export * from "./suscriptionHandler.vue?vue&type=script&lang=js&"
import style0 from "./suscriptionHandler.vue?vue&type=style&index=0&id=60f2ee38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f2ee38",
  null
  
)

export default component.exports